
































































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import formatCompetence from '@/shared/directive/format-competence';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import ProductTemplateRule from '@/domain/product-template/entity/product-template-rule.entity';
import ContractItemRule from '../../../domain/contract/entity/contract-item-rule.entity';

@Component({
  filters: {
    formatCompetence,
  },
})

export default class ContractItemRuleContent extends Vue {
  @Prop() contractItemRule!: ContractItemRule;

  @Prop() productTemplateRule!: ProductTemplateRule;

  @Prop() ruleGroup!: RuleGroup;

  @Prop() ruleGroupList!: RuleGroup[];

  @Prop() editModeValue!: boolean;

  @Emit('addRuleGroupContractItemRule')
  addRuleGroupContractItemRule(ruleGroupId: string) {
    const index = this.ruleGroupList.findIndex((el: RuleGroup) => el.id === ruleGroupId)
    return this.ruleGroupList[index];
  }
}

